import { render } from "./invoiceType.vue?vue&type=template&id=97c3fb96&scoped=true"
import script from "./invoiceType.vue?vue&type=script&lang=js"
export * from "./invoiceType.vue?vue&type=script&lang=js"

import "./invoiceType.vue?vue&type=style&index=0&id=97c3fb96&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/jk-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97c3fb96"]])

export default __exports__